<!-- <div style="position:absolute; z-index:77777; left:10px; top:10px;  background: red;
    color: #fff;">{{watchTime }}   /  {{tempInc }} </div>-->
<div class="wideoWreapper" [class.embed]="embeded"  >
	
   <!--  <div class="live-label" *ngIf="stream.viewersInWatch && stream.isRunning">
                <div class="lbl live">
                <span>LIVE</span>
                </div>
                <div class="count-watchers">
                  <span>{{viewersNow }}</span>
                  </div>
              </div>
   -->

	<div *ngIf="stream.showTransformed" (click)="toggleTransform()" class="transformX"></div>
	<div class="videoCover" *ngIf="covered"></div>
   
 <div [class.dsbl]="hideSeek" #target class="player" ></div>
</div>
